import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=37ce93e8&scoped=true&"
import script from "./NewsModal.vue?vue&type=script&lang=ts&"
export * from "./NewsModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewsModal.vue?vue&type=style&index=0&id=37ce93e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce93e8",
  null
  
)

export default component.exports